//
// Publishers we hold full-text indexing agreements with. This list is the
// single source of truth for every publisher-count claim in the product —
// the /coverage page renders it in full, and the marketing surfaces quote
// PUBLISHER_COUNT — so adding a partner here updates the copy everywhere.
//
// Treat PUBLISHER_COUNT as a floor, not the total: the list lags the real
// roster between updates, which is why the marketing copy renders it as
// "{PUBLISHER_COUNT}+" rather than an exact figure.
//
export const PUBLISHERS_LAST_UPDATED = 'June 2026'

export const PUBLISHERS = [
  'American Academy of Neurology (published by WKH)',
  'American Association for the Advancement of Science',
  'American Chemical Society',
  'American Medical Association',
  'American Physiological Society',
  'American Psychological Association',
  'American Society for Microbiology',
  'Bentham Science',
  'BioOne',
  'BMJ Publishing Group Ltd.',
  'British Editorial Society of Bone and Joint Surgery',
  'Cambridge University Press',
  'Emerald Publishing Ltd',
  'Extrica',
  'Galenos Yayinevi Trade Co. Ltd.',
  'IGI Global',
  'Index Copernicus',
  'International Union of Crystallography',
  'IOP Publishing Ltd.',
  'Karger AG',
  'Mark Allen Group',
  'Microbiology Society',
  'Premier Science',
  'Proceedings of the National Academy of Sciences',
  'Rockefeller University Press',
  'Royal Society of Chemistry',
  'SAGE',
  'SLACK',
  'Spandidos Publications',
  'SPIE',
  'The Royal Society',
  'Thieme',
  'TransTech',
  'Wiley',
  'Wolters Kluwer Healthcare'
]

export const PUBLISHER_COUNT = PUBLISHERS.length
